import type { Brief, CreateBriefRequest, UpdateBriefRequest } from "./model"
import { baseApi } from "@/base"
import type { Uuid } from "@/utils"

const api = baseApi
  .enhanceEndpoints({ addTagTypes: ["Briefs"] })
  .injectEndpoints({
    endpoints: (build) => ({
      getBriefs: build.query<Brief[], boolean | void>({
        query: (includeArchived) => ({
          url: "briefs",
          params: { includeArchived: includeArchived === true },
        }),
        providesTags: ["Briefs"],
      }),
      getBrief: build.query<Brief, Uuid>({
        query: (id) => `briefs/${id}`,
        providesTags: ["Briefs"],
      }),
      createBrief: build.mutation<Brief, CreateBriefRequest>({
        query: (body) => ({
          url: "briefs",
          method: "POST",
          body,
        }),
        invalidatesTags: ["Briefs"],
      }),
      updateBrief: build.mutation<Brief, UpdateBriefRequest>({
        query: ({ id, ...body }) => ({
          url: `briefs/${id}`,
          method: "PATCH",
          body,
        }),
        invalidatesTags: ["Briefs"],
      }),
    }),
  })

export const {
  useGetBriefsQuery,
  useGetBriefQuery,
  useCreateBriefMutation,
  useUpdateBriefMutation,
} = api
